"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataLabel = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var DataLabel = function (_a) {
    var children = _a.children, _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement(DataLabelWrapper, { style: style }, children));
};
exports.DataLabel = DataLabel;
var DataLabelWrapper = styled_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  font-size: 1rem;\n  color: ", ";\n  font-weight: 300;\n  margin-bottom: 1rem;\n"], ["\n  display: block;\n  font-size: 1rem;\n  color: ", ";\n  font-weight: 300;\n  margin-bottom: 1rem;\n"])), theme_1.colors.black50);
var templateObject_1;
//# sourceMappingURL=index.js.map